export const StateName = 'AccountState';

export interface AccountState {
  temp: any;
}

export const initialState: AccountState = {
  temp: null
};
